import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import AppContext from "../../container/context";
import Form from "../../components/form";
import { CircularProgress } from "@mui/material";
import ActionTable from "../../components/table/ActionTable";
import materialProduto from "../../enums/materialProduto";
import { mergeParams } from "../../helpers/helpers";

export default function Precos({ history, location }) {
  const { notification } = useContext(AppContext);
  const [comboEscolas, setComboEscolas] = useState([]);
  const [filtro, setFiltro] = useState(mergeParams({ escolaId: 0 }, location));

  const [carregando, setCarregando] = useState(false);
  const [escola, setEscola] = useState({});
  const [produtosEscola, setProdutosEscola] = useState([]);
  const [produtoEditar, setProdutoEditar] = useState({});

  useEffect(() => {
    if (filtro.escolaId > 0) {
      carregar();
    }

    carregarComboEscolas();
  }, []);

  const carregarComboEscolas = (escolas) => {
    api
      .get("escolas/listar", { ativas: true })
      .then((res) => {
        setComboEscolas(res);
      })
      .catch((err) => notification("error", "Erro ao listar as escolas"));
  };

  const carregar = (filtroEnviar = filtro) => {
    setFiltro(filtroEnviar);
    setCarregando(true);

    api
      .get("escolas/precos", filtroEnviar)
      .then((escolaProdutos) => {
        if (!escolaProdutos || escolaProdutos.lenght === 0)
          return notification("error", "Não há produtos para configurar.");

        const escola = escolaProdutos[0];

        escola.escolaPrecoMaterialBilingue = escola.escolaPrecoMaterialBilingue
          ? (escola.escolaPrecoMaterialBilingue / 100).toFixed(2)
          : "";
        escola.escolaPrecoMaterialUdt = escola.escolaPrecoMaterialUdt
          ? (escola.escolaPrecoMaterialUdt / 100).toFixed(2)
          : "";

        escolaProdutos.forEach((produto) => {
          if (produto.escolaProdutoValor) {
            const valorReais = (produto.escolaProdutoValor / 100).toFixed(2);

            produto.categoriaValor =
              "Preço específico do produto para a escola";

            return (produto.valor = `${valorReais}`);
          }

          if (produto.produtoValorVenda && produto.produtoValorVenda > 0) {
            const valorReais = (produto.produtoValorVenda / 100).toFixed(2);

            produto.categoriaValor = "Preço específico produto";

            return (produto.valor = `${valorReais}`);
          }

          switch (produto.produtoProdutoPerto) {
            case 1:
              if (
                produto.escolaPrecoMaterialBilingue &&
                produto.escolaPrecoMaterialBilingue > 0
              ) {
                const valorReais = (
                  produto.escolaPrecoMaterialBilingue / 100
                ).toFixed(2);

                produto.categoriaValor =
                  "Preço específico produtos Bilíngue p/ escola";

                produto.valor = `${valorReais}`;
              }

              if (
                produto.escolaGrupoPrecoBilingue &&
                produto.grupoPrecoBilingueValor > 0
              ) {
                const valorReais = (
                  produto.grupoPrecoBilingueValor / 100
                ).toFixed(2);

                produto.categoriaValor = "Grupo de preço p/ Bilíngue";

                produto.valor = `${valorReais}`;
              }

              break;
            case 2:
              if (
                produto.escolaPrecoMaterialUdt &&
                produto.escolaPrecoMaterialUdt > 0
              ) {
                const valorReais = (
                  produto.escolaPrecoMaterialUdt / 100
                ).toFixed(2);

                produto.categoriaValor =
                  "Preço específico produtos UDT p/ escola";

                produto.valor = `${valorReais}`;
              }

              if (
                produto.escolaGrupoPrecoUdt &&
                produto.grupoPrecoUdtValor > 0
              ) {
                const valorReais = (produto.grupoPrecoUdtValor / 100).toFixed(
                  2
                );

                produto.categoriaValor = "Grupo de preço p/ UDT";

                produto.valor = `${valorReais}`;
              }

              break;
          }
        });

        setCarregando(false);
        setEscola(escola);
        setProdutosEscola(escolaProdutos);
      })
      .catch((e) => notification("error", "Erro ao carregar a escola"));
  };

  const camposInclusaoEscola = () => {
    return {
      escolaId: {
        label: "Escola",
        type: "select",
        emptyItem: true,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        },
        value: filtro.escolaId,
      },
    };
  };

  const fInclusaoEscola = {
    title: "Pedido",
    form: camposInclusaoEscola(),
    submit: {
      label: "carregar",
      action: carregar,
    },

    urlParams: true,
    history,
    location,
  };

  const salvarEscolaParametros = (form) => {
    const precoMaterialBilingue = (
      Number(form.precoMaterialBilingue) * 100
    ).toFixed(0);
    const precoMaterialUdt = (Number(form.precoMaterialUdt) * 100).toFixed(0);

    const parametrosPrecos = {
      escolaId: escola.escolaId,
      precoMaterialBilingue,
      precoMaterialUdt,
    };

    api
      .post("escolas/atualizarPrecos", parametrosPrecos)
      .then(() => {
        notification("success", "Parâmetros de preços alterados com sucesso!");
        carregar({ escolaId: escola.escolaId });
      })
      .catch(() => notification("error", "Erro ao salvar o preço."));
  };

  const fParametros = {
    title: "Parâmetros",
    form: {
      precoMaterialBilingue: {
        label: "Preço material Bilíngue (específico para a escola)",
        type: "number",
        value: escola.escolaPrecoMaterialBilingue,
        space: 6,
      },
      precoMaterialUdt: {
        label: "Preço material Uni Dune Te (específico para a escola)",
        type: "number",
        value: escola.escolaPrecoMaterialUdt,
        space: 6,
      },
    },
    submit: {
      label: "salvar",
      action: salvarEscolaParametros,
    },
  };

  const selecionarEscolaProduto = (produtoEditar) => {
    produtoEditar.valorEditar = produtoEditar.escolaProdutoValor
      ? (produtoEditar.escolaProdutoValor / 100).toFixed(2)
      : null;

    setProdutoEditar(produtoEditar);
  };

  const tbProdutosEscola = {
    title: "Preços específicos para a escola",
    array: produtosEscola,
    columns: [
      {
        name: "produtoProdutoPerto",
        label: "Produto Perto",
        domain: materialProduto,
      },
      {
        name: "produtoNome",
        label: "Nome",
      },
      {
        name: "valor",
        label: "Valor (R$)",
        condStyle: (item) =>
          item.escolaProdutoValor ? { fontWeight: "bolder", fontSize: 14 } : {},
      },
      {
        name: "categoriaValor",
        label: "Categoria do valor",
        condStyle: (item) =>
          item.escolaProdutoValor ? { fontWeight: "bolder", fontSize: 14 } : {},
      },
    ],
    actions: [
      {
        name: "visualizar",
        icon: "zmdi zmdi-assignment",
        tooltip: "Alterar preço",
        title: "Incluir/editar preço específico",
        action: selecionarEscolaProduto, //produtoEditar => this.setState({produtoEditar})
      },
    ],
  };

  const salvarEscolaProduto = (form) => {
    const valorCentavos = (Number(form.valor) * 100).toFixed(0);

    const escolaProduto = {
      escolaId: produtoEditar.escolaId,
      produtoId: produtoEditar.produtoId,
      valorCentavos,
    };

    api
      .post("escolas/atualizarEscolaProduto", escolaProduto)
      .then(() => {
        notification("success", "Preço alterado com sucesso!");
        setProdutoEditar({});
        carregar({ escolaId: produtoEditar.escolaId });
      })
      .catch(() => notification("error", "Erro ao salvar o preço."));
  };

  const fProdutoPreco = {
    title: "Produto Preço",
    form: {
      produtoProdutoPerto: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Produto Perto</h4>
            <p>{materialProduto.desc(produtoEditar.produtoProdutoPerto)}</p>
          </div>
        ),
      },
      produtoNome: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Nome</h4>
            <p>{produtoEditar.produtoNome}</p>
          </div>
        ),
      },
      valor: {
        label: "Preço específico para escola (R$)",
        type: "number",
        value: produtoEditar.valorEditar,
        required: true,
        space: 4,
      },
    },
    submit: {
      label: "salvar",
      action: salvarEscolaProduto,
    },
    close: {
      label: "fechar",
      action: () => setProdutoEditar({}),
    },
  };

  return (
    <div>
      <Form formData={fInclusaoEscola} />
      {filtro.escolaId > 0 && (
        <>
          {produtoEditar.escolaId ? (
            <Form formData={fProdutoPreco} />
          ) : (
            <>
              {carregando ? (
                <CircularProgress />
              ) : (
                <>
                  <Form formData={fParametros} />
                  <ActionTable structure={tbProdutosEscola} />
                </>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
}
